<template>
  <div class="entrance-container">
    <div
      v-for="(item, index) in data"
      class="entrance-item"
      :key="index"
      @click="clickEntrance(item)"> {{ entranceText(item) }} </div>
  </div>
</template>
<script>
import { EntranceType } from '@/config/entrance.js'

export default {
  name: 'EntranceView',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  watch: {},
  methods: {
    clickEntrance(type) {
      this.$emit('clickEntrance', type)
    },
    entranceText(type) {
      switch (type) {
        case EntranceType.REGISTER:
          return this.$t('注册账号')
        case EntranceType.SMSLOGIN:
          return this.$t('短信登录')
        case EntranceType.PWDLOGIN:
          return this.$t('密码登录')
        case EntranceType.OTHERLOGIN:
          return this.$t('其它方式登录')
        case EntranceType.FORGETPWD:
          return this.$t('忘记密码')
        default:
          return ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.entrance-container{
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  .entrance-item {
    font-size: 12px;
    color: gray;
    align-items: center;
    padding: 0px 10px;
  }
  .entrance-item + .entrance-item {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      left: -1px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 12px;
      background-color: #ddd;
    }
  }

}
</style>
